import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { UserServiceService } from '../../../../Services/user.service';

@Component({
  selector: 'app-parent-staff',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './parent-staff.component.html',
  styleUrl: './parent-staff.component.css'
})
export class ParentStaffComponent implements OnInit {

  staffId!: number;
  staffName!: String;

  constructor(private route: ActivatedRoute, private userService:UserServiceService) {}

  ngOnInit(): void {
    this.staffId = Number(this.route.snapshot.paramMap.get('staffId'));
    this.getUserName(this.staffId);
  }

  getUserName(id:any){
    this.userService.getUser(id).subscribe((res:any)=>{
      console.log("user data is",res.data.name);
      this.staffName = res.data.name;
    })
  }
}
